import React from 'react';
import {
  Box,
  Flex,
  Text,
  Switch,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';

const ProfileVisibilityBanner = ({ isPublic, onChange }) => (
  <Box
    mb={6}
    p={{ base: 4, md: 5 }}
    borderRadius="xl"
    borderWidth="2px"
    borderColor={isPublic ? 'green.500' : 'gray.600'}
    bg={isPublic ? 'rgba(72, 187, 120, 0.08)' : 'gray.700'}
  >
    <Flex
      align={{ base: 'flex-start', sm: 'center' }}
      justify="space-between"
      gap={4}
      direction={{ base: 'column', sm: 'row' }}
    >
      <Box flex="1">
        <Text fontWeight="semibold" fontSize={{ base: 'md', md: 'lg' }}>
          {isPublic ? 'Il profilo è pubblico' : 'Il profilo è privato'}
        </Text>
        <Text fontSize="sm" color="gray.400" mt={1}>
          {isPublic
            ? 'Compare nella pagina Network e può essere trovato dagli altri soci.'
            : 'Non compare nel Network finché non attivi la visibilità e salvi.'}
        </Text>
      </Box>
      <FormControl display="flex" alignItems="center" w="auto" flexShrink={0}>
        <FormLabel
          htmlFor="isPublic-switch"
          mb="0"
          mr={3}
          fontSize="sm"
          whiteSpace="nowrap"
        >
          Pubblica
        </FormLabel>
        <Switch
          id="isPublic-switch"
          size="lg"
          isChecked={!!isPublic}
          onChange={(e) => onChange(e.target.checked)}
          colorScheme="green"
        />
      </FormControl>
    </Flex>
  </Box>
);

export default ProfileVisibilityBanner;
